export const BoxStatusCssClasses = [
  'info',
  'warning',
  'primary',
  'success',
  'dark',
  'danger',
];
export const BoxStatusTitles = [
  'Шинэ',
  'Трак бүртгэсэн',
  'Каргонд бүртгэсэн',
  'Хүлээн авсан',
  'Агуулахад бүртгэсэн',
  'Алдагдсан',
];
export const boxStatusList = [
  { key: 0, value: '' },
  { key: 1, value: 'Шинэ' }, //.text-info
  { key: 2, value: 'Трак бүртгэсэн' }, //.text-warning
  { key: 3, value: 'Каргонд бүртгэсэн' }, // .text-primary
  { key: 4, value: 'Хүлээн авсан' }, //.text-success
  { key: 5, value: 'Агуулахад бүртгэсэн' }, //.text-dark
  { key: 6, value: 'Алдагдсан' }, //.text-danger
];
export const receivedTypeList = [
  { key: 0, value: '' },
  { key: 1, value: 'Каргогоос очиж авсан' },
  { key: 2, value: 'Хүргэлтээр авсан' },
  { key: 3, value: 'Гаалиас авсан' },
];
export const RegisteredInCargoCssClasses = ['primary', 'danger'];
export const RegisteredInCargoTitles = ['Тийм', 'Үгүй'];

export const defaultSorted = [{ dataField: 'a.created_at', order: 'desc' }];
export const sizePerPageList = [
  { text: '10', value: 10 },
  { text: '20', value: 20 },
  { text: '50', value: 50 },
];
export const initialFilter = {
  filter: {
    from: '', //Date.now(),
    to: '', //"",
    searchText: '',
    websiteCode: '',
    status: -1,
  },
  sortOrder: 'desc', // asc||desc
  sortField: 'a.order_code',
  pageNumber: 1,
  pageSize: 10,
};

export const initialBox = {
  orderCode: '',
  orderDate: undefined,
  trackingId: '',
  websiteCode: '',
  boxStatus: 1,
  cargoCode: '',
  check: 0,
  weight: 0.0,
  cargoCostMnt: 0.0,
  receivedDate: new Date(),
  receivedType: 1,
  customTaxAmount: '0.00',
  totalCost: '0.00',
};
